export default __webpack_public_path__ + "static/media/lighty.f5277830.png";